(function () {
  function init() {
    var roomOptions = document.querySelectorAll('[data-room-type]');
    var roomValue = document.querySelector('[data-room-type-value]');
    var lengthInput = document.querySelector('[data-room-length]');
    var widthInput = document.querySelector('[data-room-width]');
    var areaInput = document.querySelector('[data-room-area]');
    var fileInput = document.querySelector('[data-room-file]');
    var fileLabel = document.querySelector('[data-file-label]');
    var planLabel = document.querySelector('[data-plan-label]');
    var planShape = document.querySelector('[data-plan-shape]');
    var contactForm = document.querySelector('#fd-free-design-contact-form');
    if (!roomOptions.length && !contactForm) return;

    function updateRoom(type) {
      roomOptions.forEach(function (option) {
        var selected = option.dataset.roomType === type;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (roomValue) roomValue.value = type;
    }

    function updatePlan() {
      var length = parseFloat(lengthInput && lengthInput.value);
      var width = parseFloat(widthInput && widthInput.value);
      if (!length || !width || length <= 0 || width <= 0) {
        if (areaInput) areaInput.value = '';
        if (planLabel) planLabel.textContent = 'Enter dimensions to preview your room plan.';
        if (planShape) planShape.style.aspectRatio = '1.6';
        return;
      }
      var area = Math.round(length * width * 10) / 10;
      if (areaInput) areaInput.value = area;
      if (planLabel) planLabel.textContent = length + ' ft x ' + width + ' ft room plan';
      if (planShape) planShape.style.aspectRatio = Math.max(.75, Math.min(2.4, length / width));
    }

    roomOptions.forEach(function (option) { option.addEventListener('click', function () { updateRoom(option.dataset.roomType); }); });
    if (lengthInput) lengthInput.addEventListener('input', updatePlan);
    if (widthInput) widthInput.addEventListener('input', updatePlan);
    if (fileInput) fileInput.addEventListener('change', function () { if (fileInput.files[0] && fileLabel) fileLabel.textContent = fileInput.files[0].name; });
    if (contactForm) {
      contactForm.setAttribute('enctype', 'multipart/form-data');
      contactForm.setAttribute('encoding', 'multipart/form-data');
      contactForm.addEventListener('submit', function () {
        var hidden = contactForm.querySelector('[data-contact-room-file]');
        if (hidden && fileInput && fileInput.files[0]) hidden.value = fileInput.files[0].name;
        var fields = [['[data-contact-length]', lengthInput], ['[data-contact-width]', widthInput], ['[data-contact-area]', areaInput]];
        fields.forEach(function (pair) { var target = contactForm.querySelector(pair[0]); if (target && pair[1]) target.value = pair[1].value; });
      });
      contactForm.addEventListener('formdata', function (event) {
        if (fileInput && fileInput.files[0]) event.formData.set('contact[room_file]', fileInput.files[0], fileInput.files[0].name);
      });
    }
    if (roomOptions.length) {
      var selectedRoom = document.querySelector('[data-room-type].is-selected');
      updateRoom(selectedRoom ? selectedRoom.dataset.roomType : roomOptions[0].dataset.roomType);
    }
    updatePlan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
}());
